export default __webpack_public_path__ + "static/media/Sample Batch Repayment Upload Sheet.25d4d91d.xlsx";